module.exports = __webpack_public_path__ + "static/media/404.0f0ef708.svg";